import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import removeSpace from './utils/removeSpace'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(removeSpace)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js